import {
  doc,
  setDoc,
  serverTimestamp,
  query,
  orderBy,
  collection,
  where,
  limit,
  getDocs
} from "firebase/firestore";

import { db } from "../firebase";
import Cookies from "js-cookie";

export const Create_plugins = async (data) => {

  const {
    plugins_name,
    plugins_description,
    pluguid,
    slug, 
  } = data || {};

  // ================= VALIDATION =================
  if (!plugins_name?.trim()) {
    return { success: false, error: "Missing plugin name" };
  }

  if (!plugins_description?.trim()) {
    return { success: false, error: "Missing plugin description" };
  }

  if (!slug?.trim()) {
    return { success: false, error: "Missing slug" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || !guid) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  try {

    const tablename = "plugins"; // ✅ lowercase recommended
    const pagesRef = collection(db, tablename);

    // ================= CHECK DUPLICATE SLUG =================
    const slugQuery = query(
      pagesRef,
      where("slug", "==", slug)
    );

    const slugSnapshot = await getDocs(slugQuery);

    if (!slugSnapshot.empty) {
      const existingDoc = slugSnapshot.docs[0].data();

      if (existingDoc.pluguid !== pluguid) {
        return { success: false, error: "Slug already exists" };
      }
    }

    // ================= HANDLE PLUGUID =================
    let finalpluguid = pluguid;

    if (!finalpluguid) {
      finalpluguid = Date.now().toString();
    }

    const docRef = doc(db, tablename, finalpluguid);

    // ================= CHECK EXISTING =================
    const existingQuery = query(
      pagesRef,
      where("pluguid", "==", finalpluguid), // ✅ FIXED
      limit(1)
    );

    const existingSnapshot = await getDocs(existingQuery);
    const isNew = existingSnapshot.empty;

    // ================= INDEX NUMBER =================
    let indexnumber = null;

    if (isNew) {
      const indexQuery = query(
        pagesRef,
        orderBy("indexnumber", "desc"),
        limit(1)
      );

      const indexSnapshot = await getDocs(indexQuery);

      if (!indexSnapshot.empty) {
        const lastIndex = indexSnapshot.docs[0].data().indexnumber || 0;
        indexnumber = lastIndex + 1;
      } else {
        indexnumber = 1;
      }
    }

    // ================= SAVE =================
    await setDoc(
      docRef,
      {
        ...data,
        pluguid: finalpluguid,
        guid, 
        sessiontoken,

        update_date_time: serverTimestamp(),

        ...(isNew && {
          date_time: serverTimestamp(),
          indexnumber
        })
      },
      { merge: true }
    );

    return { success: true };

  } catch (err) {
    console.error("❌ Error saving plugin:", err);

    return {
      success: false,
      error: err.message || "Unknown error"
    };
  }
};